import { FooterLinkType, PartnerProductConfiguration } from './types';

export const defaultLegalTermsLink = {
    type: FooterLinkType.LegalTerms,
    label: 'Legal Terms',
    url: 'https://www.asurion.com/legal/asurion',
};

export const defaultPrivacyPolicyLink = {
    type: FooterLinkType.PrivacyPolicy,
    label: 'Privacy Policy',
    url: 'https://www.asurion.com/privacy-policy/',
};

export const defaultTermsOfUseLink = {
    type: FooterLinkType.TermsOfUse,
    label: 'Terms of Use',
    url: 'https://www.asurion.com/website-terms-of-use/',
};

export const defaultPartnerProductConfiguration: PartnerProductConfiguration = {
    expertChat: {
        enabled: false,
    },
    header: {
        accountNav: { enabled: false },
        logo: {
            url: 'https://assets.asurion-ui.my.asurion53.com/images/logos/asurion-logo.svg',
            alt: 'asurion logo',
        },
        waffleMenu: { enabled: false },
    },
    i18n: {
        defaultLocale: 'en-US',
        supportedLocales: ['en-US'],
    },
    leftNav: { enabled: false },
    partnerDisplayName: '',
    productDisplayName: '',
    footer: {
        links: [
            defaultLegalTermsLink,
            defaultPrivacyPolicyLink,
            defaultTermsOfUseLink,
        ],
    },
    partnerPicker: { enabled: false },
};
